import React, { useEffect, useRef, useState } from 'react'
import MyButton from '../UI/form/MyButton'
import { useDispatch, useSelector } from 'react-redux'
import { setScannerActivate, setScannerOpen, setScannerResult, setScannerType } from '../../store/scannerSlice'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

const ScannerQrHid = ({ buttonText, onClickOpen, onClickClose, isCameraOnly }) => {

    const open = useSelector(state => state.scanner.open)
    const scanTypeUser = useSelector(state => state.user.user.scanType)
    const activate = useSelector(state => state.scanner.activate)
	const result = useSelector(state => state.scanner.result)
	const dispatch = useDispatch()

    // const [scannedData, setScannedData] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [buffer, setBuffer] = useState('');

    const timeoutRef = useRef(null);

    useEffect(() => {
        // Примусове відкриття потрібного сканеру, якщо є в налаштуваннях у користувача
        if (scanTypeUser && activate && !isCameraOnly) {
            if (scanTypeUser === 'hid') {
                openScannerHid()
            }
        }
    }, [activate, scanTypeUser])

    useEffect(() => {
        const handleKeyDown = (e) => {
        if (!isListening) return;

        const key = e.key;

        if (key === 'Enter') {
            // setScannedData(buffer);
            // Закриваємо вікно
            dispatch(setScannerOpen(false))
            // Зберігаємо результат
            dispatch(setScannerResult(buffer))
            // Завершуємо сканер
            stopListening();
            return;
        }

        if (key.length === 1) {
            setBuffer(prev => prev + key);
        }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isListening, buffer]);

    const openScannerHid = (e) => {
        // Початок очікування введення
        if (!open) {
            if (onClickOpen) {
                onClickOpen(true)
            }
        }
        dispatch(setScannerType('hid'))
        dispatch(setScannerOpen(true))
        startListening()
    }

    const startListening = () => {
        setBuffer('');
        // setScannedData('');
        dispatch(setScannerResult(''))
        setIsListening(true);

        // Скасовуємо попередній таймер, якщо був
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Встановлюємо таймер на 10 секунд
        timeoutRef.current = setTimeout(() => {
            stopScanner()
        }, 20000); // 10 000 мс = 10 сек
    };

    const stopListening = () => {
        setIsListening(false);
        setBuffer('');
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    const stopScanner = () => {
        stopListening()
        dispatch(setScannerOpen(false))
        dispatch(setScannerActivate(false))
    }

  return (
    <div>
        {
            scanTypeUser && scanTypeUser === 'camera' && !isCameraOnly ? '' 
			:
            <MyButton
                onClick={e => openScannerHid (e)} 
                disabled={isListening || open}
            >
                {
                    buttonText ? buttonText : <QrCodeScannerIcon sx={{color: 'red'}} />
                }
                сканер {isListening ? ' (очікування 20 сек...)' : ''}
            </MyButton>
        }
    </div>
  )
}

export default ScannerQrHid